import { useState, useEffect } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Layout from "../../layout/default";

import Block from "../../components/Block/Block";
import CircularProgress from "@mui/material/CircularProgress";

import FormControl from "@mui/material/FormControl";
import { rootURL } from "../utilities/axios-config";
import { Button, Chip, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { failedMessage, successMessage } from "../utilities/alert-config";
import axios from "axios";
import dayjs from "dayjs";
import { useS3UploadMultipleFiles } from "../../hooks/useS3";
import CommentComponent from "./CommentComponent";

function KanbanView() {
  const { idd, labels } = useParams();
  const userId = localStorage.getItem("id");
  const userRole = localStorage.getItem("role");
  const { uploadFiles } = useS3UploadMultipleFiles();
  const [label, setlabel] = useState("");
  const [assignee, setassignee] = useState([]);
  const [priority, setpriority] = useState("");
  const [title, settitle] = useState("");
  const [content, setcontent] = useState("");
  const [duedate, setduedate] = useState("");
  const [picture, setpicture] = useState(
    "/images/avatar/avatar-placeholder.jpg"
  );
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [editingComment, setEditingComment] = useState(null);
  const [replingComment, setReplingComment] = useState(null);
  const [loading2, setloading2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addNewCommentStatus, setAddNewCommentStatus] = useState(null);
  const [showAddComment, setShowAddComment] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const tableAukissBoardShow = async () => {
    try {
      const userToken = localStorage.getItem("userToken");
      const config = {
        headers: {
          Authorization: `Bearer ${userToken}`,
          "Content-Type": "application/json",
        },
      };

      let url = "";
      let labs = "";
      if (labels === "InProgress") {
        let labeld = "In Progress";
        url = `${rootURL}/view_kanboard_cpanel/${idd}/${labeld}`;
        labs = labeld;
      } else if (labels === "InReview") {
        let labeld = "In Review";
        url = `${rootURL}/view_kanboard_cpanel/${idd}/${labeld}`;
        labs = labeld;
      } else {
        let labeld = labels;
        url = `${rootURL}/view_kanboard_cpanel/${idd}/${labeld}`;
        labs = labeld;
      }

      setloading2(true);
      fetch(url, config)
        .then((row) => row.json())
        .then((row) => {
          if (row?.success === true) {
            // eslint-disable-next-line
            const kanbanaukiss = row?.data ? row?.data[0] : null;
            console.log("kanbanaukiss", kanbanaukiss);
            // console.log("arr", arr.items);
            setpicture(kanbanaukiss?.items?.picture ?? "");
            setlabel(kanbanaukiss?.items?.label ?? labs);
            settitle(kanbanaukiss?.items?.title ?? "");
            setcontent(kanbanaukiss?.items?.content ?? "");
            setassignee(kanbanaukiss?.items?.assignee_new ?? []);
            setduedate(kanbanaukiss?.items?.duedate ?? "");
            setpriority(kanbanaukiss?.items?.priority ?? "");
            // setcomment(kanbanaukiss?.items?.comment ?? "");
            setComments(kanbanaukiss?.items?.comments ?? []);
            // row?.data?.map((arr) => {

            // });

            setloading2(false);
          } else if (row?.success === false) {
            setloading2(false);
          }
        })
        .finally(() => {
          setloading2(false);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    tableAukissBoardShow();
    // eslint-disable-next-line
  }, [idd, labels]);

  const handleCommentFileChange = async (event) => {
    setAttachedFiles((prev) => [...prev, ...Array.from(event.target.files)]);
  };

  const handleNewCommentSubmit = async () => {
    if (newComment.trim() === "") return;
    setLoading(true);

    let imageUrls = [];
    if (attachedFiles.length > 0) {
      setAddNewCommentStatus("Uploading...");
      const uploadFilesUrls = await uploadFiles(attachedFiles);
      if (uploadFilesUrls) {
        imageUrls = uploadFilesUrls;
      }
    }

    const newCommentData = {
      user_id: userId,
      kanbanbord_details_id: idd,
      content: newComment?.trim(),
      images_urls: imageUrls,
    };

    const userToken = localStorage.getItem("userToken");
    setAddNewCommentStatus("Saving...");
    try {
      const response = await axios.post(
        `${rootURL}/kanban/comments`,
        newCommentData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result.success === true) {
        successMessage("Success");
        setNewComment("");
        setAttachedFiles([]);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (result.success === false) {
        failedMessage(result.message);
      }
    } catch (error) {
      console.log("Error>>>>", error);

      // failedMessage("Internal Server Error");
      failedMessage(error.message || "An error occurred");
    } finally {
      setLoading(false);
      setAddNewCommentStatus(null);
    }
  };

  return (
    <>
      {loading2 ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress size={70} thickness={4} />
          </div>
        </>
      ) : (
        <>
          <Layout title="View Aukiss Board" content="container">
            <Block.Head>
              <Block.HeadBetween>
                <Block.HeadContent>
                  <Block.Title tag="h2">View Aukiss Board</Block.Title>
                  <nav>
                    <ol className="breadcrumb breadcrumb-arrow mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/apps/kanbanaukiss-list">Aukiss Board</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        View Board
                      </li>
                    </ol>
                  </nav>
                </Block.HeadContent>
              </Block.HeadBetween>
            </Block.Head>

            <Block>
              <Form>
                <Row className="g-gs">
                  <Col xxl="9">
                    <div className="gap gy-4">
                      <div className="gap-col">
                        <Card className="card-gutter-md">
                          <Card.Body>
                            <Row className="g-gs">
                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label>Cover</Form.Label>
                                  <div className="form-control-wrap">
                                    <div className="image-upload-wrap d-flex flex-column align-items-center">
                                      <img
                                        id="image-result1add"
                                        src={picture}
                                        alt="avatar"
                                      />
                                    </div>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <FormControl fullWidth>
                                    <Form.Label htmlFor="productname">
                                      Label
                                    </Form.Label>
                                    <div>
                                      <Chip
                                        label={label}
                                        variant="filled"
                                        style={{
                                          fontSize: "16px",
                                          padding: "10px",
                                        }}
                                      />
                                    </div>
                                  </FormControl>
                                </Form.Group>
                              </Col>
                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="productname">
                                    Title
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    <Typography variant="p" gutterBottom>
                                      {title}
                                    </Typography>
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="productname">
                                    Description
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    <Typography variant="p" gutterBottom>
                                      {content}
                                    </Typography>
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <div className="form-control-wrap">
                                  <FormControl fullWidth size="small">
                                    <Form.Label htmlFor="status_id">
                                      Assignee
                                    </Form.Label>
                                    <div>
                                      {assignee.map((item) => (
                                        <Chip
                                          key={item.id + "assignee"}
                                          label={
                                            item.firstName + " " + item.lastName
                                          }
                                          variant="filled"
                                          style={{
                                            fontSize: "16px",
                                            padding: "10px",
                                            marginRight: "20px",
                                          }}
                                        />
                                      ))}
                                    </div>
                                  </FormControl>
                                </div>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="productname">
                                    Due Date
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    <Typography variant="p" gutterBottom>
                                      {dayjs(duedate).format("DD/MM/YYYY") ===
                                      "Invalid Date"
                                        ? "N/A"
                                        : dayjs(duedate).format("DD/MM/YYYY")}
                                    </Typography>
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="productname">
                                    Priority
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    <Chip
                                      label={priority}
                                      variant="filled"
                                      color={
                                        priority === "High"
                                          ? "error"
                                          : priority === "Medium"
                                          ? "warning"
                                          : "primary"
                                      }
                                      style={{
                                        fontSize: "16px",
                                        padding: "10px",
                                      }}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="productname">
                                    Comments
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    {/* Display existing comments */}
                                    <div className="mb-3">
                                      {comments.length > 0 ? (
                                        comments.map((comment) => (
                                          <CommentComponent
                                            key={comment.id}
                                            comment={comment}
                                            setShowImageModal={
                                              setShowImageModal
                                            }
                                            setSelectedImage={setSelectedImage}
                                            setNewComment={setNewComment}
                                            setShowAddComment={
                                              setShowAddComment
                                            }
                                          />
                                        ))
                                      ) : (
                                        <div>
                                          <p>No comments yet.</p>
                                          <hr />
                                        </div>
                                      )}
                                    </div>

                                    {/* Add a new comment */}

                                    {showAddComment ? (
                                      <div>
                                        <Form.Group className="form-group mb-2">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <Form.Label>Add comment</Form.Label>
                                            <Tooltip title="Cancel">
                                              <IconButton
                                                onClick={() => {
                                                  setNewComment("");
                                                  setShowAddComment(false);
                                                }}
                                              >
                                                <CloseIcon size="small" />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                          <div className="form-control-wrap">
                                            <Form.Control
                                              as="textarea"
                                              rows="3"
                                              placeholder="Add comment"
                                              value={newComment}
                                              required
                                              onChange={(e) =>
                                                setNewComment(e.target.value)
                                              }
                                            ></Form.Control>
                                          </div>
                                        </Form.Group>

                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="warning"
                                              onClick={handleNewCommentSubmit}
                                              style={{
                                                marginRight: "10px",
                                                textTransform: "none",
                                              }}
                                              disabled={
                                                newComment.trim() === "" ||
                                                loading
                                              }
                                            >
                                              {loading && addNewCommentStatus
                                                ? addNewCommentStatus
                                                : "Send"}
                                            </Button>
                                            <Button
                                              variant="text"
                                              component="label"
                                              style={{
                                                textTransform: "none",
                                                textDecoration: "underline",
                                              }}
                                            >
                                              Attach file
                                              <input
                                                type="file"
                                                hidden
                                                multiple
                                                onChange={
                                                  handleCommentFileChange
                                                }
                                                style={{ marginRight: "10px" }}
                                              />
                                            </Button>
                                          </div>
                                        </div>

                                        {/* Display attached files */}
                                        <div className="mt-2">
                                          {attachedFiles.length > 0 &&
                                            attachedFiles.map((file, index) => (
                                              <div
                                                key={index}
                                                className="d-flex align-items-center"
                                              >
                                                <span>{file?.name}</span>
                                                <Button
                                                  size="small"
                                                  variant="text"
                                                  color="error"
                                                  onClick={() =>
                                                    setAttachedFiles((prev) =>
                                                      prev.filter(
                                                        (f) =>
                                                          f.name !== file.name
                                                      )
                                                    )
                                                  }
                                                >
                                                  X
                                                </Button>
                                              </div>
                                            ))}
                                        </div>
                                      </div>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => {
                                          setEditingComment(null);
                                          setReplingComment(null);
                                          setShowAddComment(true);
                                        }}
                                      >
                                        Add Comment
                                      </Button>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Block>
          </Layout>

          {/* Custom Image Preview Modal */}
          {showImageModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1050,
                // padding: "20px",
              }}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // padding: "30px",
                  // backgroundColor: '#f5f7fa',
                  // minHeight: "400px",
                  // minWidth: "300px",
                  // minWidth: "100%",
                  // minHeight: "100%",
                  // width: "90%",
                  // height: "90%",
                  maxWidth: "80%",
                  maxHeight: "80%",
                  // maxHeight: "90vh",
                  // overflow: "auto",
                  margin: "auto",
                }}
              >
                <IconButton
                  onClick={() => {
                    setShowImageModal(false);
                    setSelectedImage(null);
                  }}
                  style={{
                    position: "absolute",
                    right: "0",
                    top: "-25px",
                  }}
                  aria-label="Close"
                >
                  <CloseIcon style={{ color: "white" }} />
                </IconButton>
                <img
                  src={selectedImage}
                  alt="Preview"
                  style={{
                    width: "90%",
                    height: "90%",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default KanbanView;
